let splideInstance = null;

let isZoomed = false;
let currentScale = 1;
let currentX = 0;
let currentY = 0;
let startX = 0;
let startY = 0;
let isDragging = false;
let zoomContainer = null;
let lastTap = 0;

const ZOOM_SCALE = 2;

function handleSlider() {
  const isMobile = window.innerWidth <= 768.98;
  
  if (isMobile && !splideInstance) {
    splideInstance = new Splide('.splide.zoom-gallery', {
      type: 'slide',
      autoplay: false,
      autoWidth: true,
      focus: 'center',
      speed: 400,
      perPage: 1,
      direction: 'ltr',
      pagination: false,
      easing: 'ease',
      drag: true
    });
    splideInstance.mount();
    
    setTimeout(() => addZoomEvents(), 100);
  } else if (!isMobile && splideInstance) {
    removeZoomEvents();
    if (isZoomed) closeZoom();
    splideInstance.destroy();
    splideInstance = null;
  }
}

function createZoomContainer() {
  if (document.querySelector('.custom-zoom-container')) return;

  const container = document.createElement('div');
  container.className = 'custom-zoom-container';
  container.style.cssText = `
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: #FFFFFF;
    z-index: 999999999;
    display: none;
    overflow: hidden;
    touch-action: none;
  `;

  const zoomWrap = document.createElement('div');
  zoomWrap.className = 'custom-zoom-wrap';
  zoomWrap.style.cssText = `
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    transition: transform 0.3s ease;
    touch-action: none;
    will-change: transform;
    z-index: 2;
  `;

  container.addEventListener('click', (e) => {
    if (e.target === container) {
      closeZoom();
    }
  });

  container.addEventListener('touchend', (e) => {
    if (e.target === container) {
      e.preventDefault();
      closeZoom();
    }
  });

  zoomWrap.addEventListener('dblclick', (e) => {
    e.preventDefault();
    e.stopPropagation();
    closeZoom();
  });

  let lastTapZoom = 0;
  zoomWrap.addEventListener('touchstart', (e) => {
    const currentTime = new Date().getTime();
    const tapLength = currentTime - lastTapZoom;
    
    if (tapLength < 500 && tapLength > 0) {
      e.preventDefault();
      e.stopPropagation();
      closeZoom();
    }
    
    lastTapZoom = currentTime;
  });

  container.appendChild(zoomWrap);
  document.body.appendChild(container);
  
  zoomContainer = container;
}

function addZoomEvents() {
  if (window.innerWidth > 768.98) return;
  
  const slides = document.querySelectorAll('.splide.zoom-gallery .splide__slide');
  
  slides.forEach(slide => {
    slide.removeEventListener('dblclick', handleDoubleClick);
    slide.removeEventListener('touchstart', handleTouchStart);
    
    slide.addEventListener('dblclick', handleDoubleClick);
    slide.addEventListener('touchstart', handleTouchStart, { passive: false });
    slide.style.userSelect = 'none';
    slide.style.webkitUserSelect = 'none';
  });

  createZoomContainer();
}

function removeZoomEvents() {
  const slides = document.querySelectorAll('.splide.zoom-gallery .splide__slide');
  slides.forEach(slide => {
    slide.removeEventListener('dblclick', handleDoubleClick);
    slide.removeEventListener('touchstart', handleTouchStart);
  });
}

function handleTouchStart(e) {
  if (isZoomed) return;
  
  const currentTime = new Date().getTime();
  const tapLength = currentTime - lastTap;
  
  if (tapLength < 500 && tapLength > 0) {
    e.preventDefault();
    e.stopPropagation();
    handleDoubleClick(e);
  }
  
  lastTap = currentTime;
}

function handleDoubleClick(e) {
  e.preventDefault();
  e.stopPropagation();
  
  if (isZoomed) {
    closeZoom();
    return;
  }

  const slide = e.currentTarget;
  
  let img = slide.querySelector('img');
  if (!img && slide.tagName === 'IMG') {
    img = slide;
  }
  
  if (!img) return;

  openZoom(img, e);
}

function openZoom(img, e) {
  if (!zoomContainer) createZoomContainer();

  const zoomWrap = zoomContainer.querySelector('.custom-zoom-wrap');
  const clonedImg = img.cloneNode(true);
  
  zoomWrap.innerHTML = '';
  zoomWrap.appendChild(clonedImg);

  const rect = img.getBoundingClientRect();
  const imgWidth = rect.width;
  const imgHeight = rect.height;

  clonedImg.style.cssText = `
    display: block;
    width: ${imgWidth}px;
    height: ${imgHeight}px;
    max-width: none;
    max-height: none;
    user-select: none;
    -webkit-user-select: none;
  `;

  const touch = e.touches ? e.touches[0] : e;
  const clickX = touch ? touch.clientX - rect.left : rect.width / 2;
  const clickY = touch ? touch.clientY - rect.top : rect.height / 2;
  
  const clickPercentX = (clickX / imgWidth) - 0.5;
  const clickPercentY = (clickY / imgHeight) - 0.5;

  currentScale = ZOOM_SCALE;
  currentX = -clickPercentX * imgWidth * (currentScale - 1);
  currentY = -clickPercentY * imgHeight * (currentScale - 1);

  limitPan(imgWidth, imgHeight);
  updateTransform(zoomWrap);
  
  zoomContainer.style.display = 'block';
  isZoomed = true;

  document.body.style.overflow = 'hidden';
  document.documentElement.style.overflow = 'hidden';

  zoomContainer.addEventListener('touchstart', handleZoomTouchStart, { passive: false });
  zoomContainer.addEventListener('touchmove', handleZoomTouchMove, { passive: false });
  zoomContainer.addEventListener('touchend', handleZoomTouchEnd, { passive: false });
  
  document.addEventListener('touchstart', preventNativeZoom, { passive: false });
  document.addEventListener('touchmove', preventNativeZoom, { passive: false });
}

function closeZoom() {
  if (!isZoomed) return;

  zoomContainer.style.display = 'none';
  document.body.style.overflow = '';
  document.documentElement.style.overflow = '';
  
  isZoomed = false;
  currentScale = 1;
  currentX = 0;
  currentY = 0;

  zoomContainer.removeEventListener('touchstart', handleZoomTouchStart);
  zoomContainer.removeEventListener('touchmove', handleZoomTouchMove);
  zoomContainer.removeEventListener('touchend', handleZoomTouchEnd);
  
  document.removeEventListener('touchstart', preventNativeZoom);
  document.removeEventListener('touchmove', preventNativeZoom);
}

function preventNativeZoom(e) {
  if (e.touches && e.touches.length > 1) {
    e.preventDefault();
  }
}

function updateTransform(element) {
  element.style.transform = `translate(-50%, -50%) translate3d(${currentX}px, ${currentY}px, 0) scale(${currentScale})`;
}

function handleZoomTouchStart(e) {
  e.preventDefault();
  e.stopPropagation();
  
  if (e.touches.length === 1) {
    isDragging = true;
    startX = e.touches[0].clientX - currentX;
    startY = e.touches[0].clientY - currentY;
  }
}

function handleZoomTouchMove(e) {
  e.preventDefault();
  e.stopPropagation();
  
  if (!isDragging || e.touches.length !== 1) return;

  const newX = e.touches[0].clientX - startX;
  const newY = e.touches[0].clientY - startY;

  const img = zoomContainer.querySelector('img');
  if (!img) return;

  const imgWidth = img.offsetWidth;
  const imgHeight = img.offsetHeight;

  currentX = newX;
  currentY = newY;

  limitPan(imgWidth, imgHeight);

  const zoomWrap = zoomContainer.querySelector('.custom-zoom-wrap');
  updateTransform(zoomWrap);
}

function handleZoomTouchEnd(e) {
  e.preventDefault();
  e.stopPropagation();
  isDragging = false;
}

function limitPan(imgWidth, imgHeight) {
  const maxX = (imgWidth * (currentScale - 1)) / 2;
  const maxY = (imgHeight * (currentScale - 1)) / 2;

  currentX = Math.max(-maxX, Math.min(maxX, currentX));
  currentY = Math.max(-maxY, Math.min(maxY, currentY));
}

function handleResize() {
  if (window.innerWidth > 768.98 && isZoomed) {
    closeZoom();
  }
}

handleSlider();
window.addEventListener('resize', handleSlider);
window.addEventListener('resize', handleResize);
window.addEventListener('orientationchange', handleResize);

document.addEventListener('DOMContentLoaded', function() {
  const gallery = document.querySelector('.media-gallery__viewer');
  const mediaViewer = document.querySelector('.media-viewer');
  const zoomGallery = document.querySelector('.splide.zoom-gallery');
  const zoomSlides = document.querySelectorAll('.splide.zoom-gallery .splide__slide');
  
  if (!gallery || !mediaViewer || !zoomGallery) return;

  let hoverImage = null;

  function createHoverImage() {
    hoverImage = document.createElement('img');
    hoverImage.src = 'https://cdn.shopify.com/s/files/1/0309/3820/2250/files/cursor-zoom.svg';
    hoverImage.style.cssText = `
      position: fixed;
      pointer-events: none;
      z-index: 999;
      max-width: 200px;
      max-height: 200px;
      object-fit: contain;
      transform: translate(-50%, -50%);
      display: none;
    `;
    document.body.appendChild(hoverImage);
  }

  function cleanUrl(url) {
    return url.split('?')[0];
  }

  function findMatchingSlide(targetSrc) {
    const cleanTargetSrc = cleanUrl(targetSrc);
    return Array.from(zoomSlides).find(slide => {
      const slideSrc = cleanUrl(slide.src);
      return slideSrc === cleanTargetSrc;
    });
  }

  function scrollToMatchingImage(targetSrc) {
    const matchingSlide = findMatchingSlide(targetSrc);
    if (matchingSlide) {
      matchingSlide.scrollIntoView({ 
        behavior: 'instant', 
        block: 'center' 
      });
    }
  }

  function goToMatchingSlide(targetSrc) {
    if (!splideInstance) return;
    
    const cleanTargetSrc = cleanUrl(targetSrc);
    const slideIndex = Array.from(zoomSlides).findIndex(slide => {
      const slideSrc = cleanUrl(slide.src);
      return slideSrc === cleanTargetSrc;
    });
    
    if (slideIndex !== -1) {
      splideInstance.go(slideIndex);
    }
  }

  function isVideoElement(element) {
    return element.closest('[data-media-type*="video"]') !== null;
  }

  mediaViewer.addEventListener('mouseenter', function() {
    if (window.innerWidth <= 768.98) return;
    if (!hoverImage) createHoverImage();
    document.body.style.cursor = 'none';
  });

  mediaViewer.addEventListener('mousemove', function(e) {
    if (window.innerWidth <= 768.98) return;
    if (!hoverImage) return;

    // Vérifier si on survole un élément vidéo
    if (isVideoElement(e.target)) {
      hoverImage.style.display = 'none';
      document.body.style.cursor = '';
    } else {
      hoverImage.style.display = 'block';
      hoverImage.style.left = e.clientX + 'px';
      hoverImage.style.top = e.clientY + 'px';
      document.body.style.cursor = 'none';
    }
  });

  mediaViewer.addEventListener('mouseleave', function() {
    if (window.innerWidth <= 768.98) return;
    if (hoverImage) {
      hoverImage.style.display = 'none';
    }
    document.body.style.cursor = '';
  });

  gallery.addEventListener('click', function(e) {
    // Vérifier si le clic provient d'un bouton de contrôle
    if (e.target.closest('.media-ctrl__btn')) {
      return; // Ne rien faire si c'est un bouton de contrôle
    }
    
    // Vérifier si le clic provient d'un élément vidéo
    if (isVideoElement(e.target)) {
      return; // Ne rien faire si c'est une vidéo
    }
    
    zoomGallery.classList.add('block');
    setTimeout(function () {
      zoomGallery.classList.add('active');
      setTimeout(() => addZoomEvents(), 100);
    }, 0);
    
    const targetImg = e.target.closest('img');
    if (targetImg) {
      if (window.innerWidth <= 768.98) {
        goToMatchingSlide(targetImg.src);
      } else {
        scrollToMatchingImage(targetImg.src);
      }
    }
  });

  document.querySelector(".splide.zoom-gallery .close-zoom").addEventListener('click', function(e) {
    removeZoomEvents();
    if (isZoomed) closeZoom();
    zoomGallery.classList.remove('block', 'active');
  });

  document.querySelector(".splide.zoom-gallery ").addEventListener('click', function(e) {
    if(e.target.classList.contains("splide__track")){
      removeZoomEvents();
      if (isZoomed) closeZoom();
      zoomGallery.classList.remove('block', 'active');
    }
  });

});